import React,{Component} from "react";
import {getZykStoryDetail} from '../../actions';
import {connect} from "react-redux";
import $ from 'jquery';
import {removejscssfile} from "../../utils";

class NewsDetail extends Component {

    constructor(props) {
        super(props)
        this.state = {
            content: {},
            type: 0,
        }
    }

    // 在组件即将被挂载到页面的时刻执行
    componentWillMount() {
        let param = {
            id: this.props.match.params.id,
            resourceType: this.props.match.params.resourceType,
        }
        getZykStoryDetail(param, this.updateNewDetailsPage.bind(this))

        //如果修改了 webpack的输出文件名称，就需要修改 chunk的文件名称了
        removejscssfile('chunk.css','css');

    }

    /**
     * 刷新详情信息
     * @param res
     */
    updateNewDetailsPage(res) {

        //视频，音频特殊处理
        let content=res.content;
        let video_res = /<embed[^>]*vsbmp4video="true"[^>]*>/g;
        if(video_res.test(content)){
            content = content.replace(video_res, function (match) {
                return match.replace("<embed","<video").replace("src=\"","old_src=\"").replace(/ue_src=\"([^\"]*)/,"src=\"$1?.mp4");
            })
        }

        let audio_res = /<embed[^>]*vsbmp3audio="true"[^>]*>/g;
        if(audio_res.test(content)){
            content = content.replace(audio_res, function(embedHTML){
                let realSrc = embedHTML.replace(/.*vsb_data="([^"]*)".*/, "$1");
                embedHTML = embedHTML.replace(/(src=")[^"]*"/, "$1"+realSrc+"?e=.mp3\"");
                return embedHTML;
            });
        }

       res.content=content;
        this.setState({
            content: res
        });
    }


    //页面state或props发生变化时执行
    render() {
        let height=window.innerHeight-10;
        console.info("this.state.content", this.state.content);
        let Content;
        if (this.state.type == 7) {
            Content = <div className="weibo-all"
                           style={{paddingTop: "10px", height:'100%',overflow:'auto'}}>
                <div className="weibo-context">
                    {this.state.content.content}
                </div>

                <div class="weibo-image">{this.state.content.picUrl?<img src={this.state.content.picUrl} alt="微博图片"/>:""}
                </div>
                <p class="weibo-url"><a target="_blank"
                                        href={this.state.content.newsLink}>{this.state.content.newsLink}</a></p>
            </div>;
        } else {
            Content = <div className='story-all' style={{paddingTop: "10px",height:'100%',  overflow:'auto'}}
                           dangerouslySetInnerHTML={{__html: this.state.content.content}}>
            </div>
        }
        ;

        return (
            <div style={{backgroundColor:'#FAFAFA'}}>
                {Content}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        tableKey: state.zykReducer.tableKey,
    }
}

export default connect(mapStateToProps)(NewsDetail);
